import { render, staticRenderFns } from "./BuyingProcess.vue?vue&type=template&id=3479f854"
import script from "./BuyingProcess.vue?vue&type=script&lang=js"
export * from "./BuyingProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports